// extracted by mini-css-extract-plugin
export default {"banner":"sxcYYaw","content":"OeteY9C","image":"ESNLQrx","textContainer":"V80QMiI","headline":"UBkrjWc","text":"gaeWIr7"};